import React, { createContext, useContext, useState, useCallback } from "react";
import UnauthorizedPopup from "../components/elements/UnauthorizedPopup";

// Initialize context with default values
const RoleContext = createContext({
  handleUnauthorized: () => {},
  showUnauthorizedPopup: false,
});

// Export the hook with a null check
export const useRole = () => {
  const context = useContext(RoleContext);
  if (context === undefined) {
    throw new Error('useRole must be used within a RoleProvider');
  }
  return context;
};

export const RoleProvider = ({ children }) => {
  const [showUnauthorizedPopup, setShowUnauthorizedPopup] = useState(false);

  const handleUnauthorized = useCallback(() => {
    if (!showUnauthorizedPopup) {
      setShowUnauthorizedPopup(true);
    }
  }, [showUnauthorizedPopup]);

  const value = {
    handleUnauthorized,
    showUnauthorizedPopup,
  };

  return (
    <RoleContext.Provider value={value}>
      {showUnauthorizedPopup && <UnauthorizedPopup />}
      {children}
    </RoleContext.Provider>
  );
}; 